import DutyCalculationPage from 'src/views/abi/DutyCalculationPage'
import pathMap from 'src/paths/pathMap'

class AbiDutyCalculationRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.ABI_DUTY_CALCULATION,
        component: DutyCalculationPage
      }
    ]
  }
}

export default AbiDutyCalculationRoute
